<template>
  <div class="pa-5 pt-2">
    <!-- <v-row>
      <v-col class="pb-0" cols="12">
        <v-btn color="warning" @click.stop="reload()">
          <v-icon left>
            mdi-cached
          </v-icon> 
          Reload
        </v-btn>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12">
        <cogs-summary-data-table :refresh="isRefresh" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CogsSummaryDataTable from './DataTable'
export default {
  name: 'cogs-summary',
  components: {
    CogsSummaryDataTable
  },
  props: [
    'refresh'
  ],
  data() {
    return {
      isRefresh: 1
    }
  },
  methods: {
    reload() {
      this.isRefresh += 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?47c49b6f